module.exports = __webpack_public_path__ + "img/04.970180c9.jpg";